import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Users, KanbanSquare, ArrowRight } from "lucide-react";

export default function RecruiterDashboard() {
  const [talentCount, setTalentCount] = useState(0);
  const [applicationCount, setApplicationCount] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const [talent, apps] = await Promise.all([
          api.get("/talent/search"),
          api.get("/applications/received"),
        ]);
        setTalentCount(talent.data.length);
        setApplicationCount(apps.data.length);
      } catch {
        // ignore
      }
    };
    load();
  }, []);

  return (
    <div data-testid="recruiter-dashboard" className="grid md:grid-cols-2 gap-6">
      <Link
        to="/talent"
        data-testid="recruiter-talent-link"
        className="bg-white rounded-xl border border-slate-200 p-8 hover:border-brand-turquoise hover:shadow-md transition-all duration-200 group"
      >
        <span className="w-12 h-12 rounded-xl bg-brand-turquoise/10 flex items-center justify-center mb-4">
          <Users className="w-6 h-6 text-brand-turquoise" />
        </span>
        <p className="text-2xl font-extrabold text-brand-navy mb-1">{talentCount}</p>
        <p className="font-semibold text-brand-navy mb-1 group-hover:text-brand-turquoise transition-colors">
          Talent Pool international
        </p>
        <p className="text-sm text-slate-500 mb-4">
          Recherchez des candidats par métier, compétences, pays et langues.
        </p>
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-turquoise">
          Rechercher des candidats <ArrowRight className="w-4 h-4" />
        </span>
      </Link>

      <Link
        to="/pipeline"
        data-testid="recruiter-pipeline-link"
        className="bg-white rounded-xl border border-slate-200 p-8 hover:border-brand-blue hover:shadow-md transition-all duration-200 group"
      >
        <span className="w-12 h-12 rounded-xl bg-brand-blue/10 flex items-center justify-center mb-4">
          <KanbanSquare className="w-6 h-6 text-brand-blue" />
        </span>
        <p className="text-2xl font-extrabold text-brand-navy mb-1">{applicationCount}</p>
        <p className="font-semibold text-brand-navy mb-1 group-hover:text-brand-blue transition-colors">
          Pipeline ATS
        </p>
        <p className="text-sm text-slate-500 mb-4">
          Suivez toutes les candidatures dans le pipeline, du nouveau candidat à l'embauche.
        </p>
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-brand-blue">
          Ouvrir le pipeline <ArrowRight className="w-4 h-4" />
        </span>
      </Link>
    </div>
  );
}
